import { makeStyles, Theme } from '@material-ui/core/styles';
import { blue } from '@material-ui/core/colors';

export const useStyles = makeStyles((theme: Theme) => ({
  label: {
    margin: theme.spacing(1),
    marginBottom: theme.spacing(2),
    fontSize: 25,
    color: 'black',
  },
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    fontSize: '20px',
    color: 'black',
  },
  info: {
    fontSize: '17px',
    color: 'rgb(0 0 0 / 70%)',
  },
  link: {
    fontSize: '17px',
    color: '#FF505F',
    marginRight: '5px',
    cursor: 'pointer',
  },
  paper: {
    paddingTop: theme.spacing(1),
    padding: theme.spacing(3),
    width: '60%',
  },
  btn: {
    marginTop: theme.spacing(5),
    '& .MuiButton-label': {
      textTransform: 'none',
    },
  },
  textField: {
    width: '75%',
    marginRight: theme.spacing(2),
    color: 'rgb(0 0 0 / 87%)',
  },
  row: {
    margin: theme.spacing(3, 3, 0, 0),
  },
  keywordTitle: {
    margin: theme.spacing(6, 3, 0, 0),
  },
  keywords: {
    marginLeft: theme.spacing(3),
    color: blue[700],
  },
  table: {
    border: '1px solid black',
    padding: theme.spacing(3, 6),
  },
}));
